<template>
  <section>
    <b-container class="w-75 p-3">
      <div class="h5 display-4 mt-1 mb-4 font-weight-bold">Teaching</div>

      <div v-if="isFetching" class="d-flex justify-content-center mt-4 header__title">
        <b-spinner />
      </div>

      <div v-else class="container__live-sections">
        <list-live-session
          v-for="(section, index) in sections"
          :key="`section__live-${section.id}`"
          :index="index"
          :learning-unit="section.learning_unit"
          :section="section"
          :show-status="false"
          :show-last-enrollment-time="false"
          :editable="false"
          :previous-path="$route.fullPath"
          show-learning-unit-name
          class="card__live-section"
        />
      </div>
    </b-container>
  </section>
</template>

<script>
import { map } from 'lodash';
import { ListLiveSession } from '../Section/components';
import { Section, User } from '@/models';

export default {
  name: 'PageTeaching',

  components: {
    ListLiveSession
  },

  data() {
    return {
      sectionsIds: [],
      isFetching: false
    };
  },

  computed: {
    sections() {
      return Section.query()
        .with('learning_unit')
        .with('section_repeat')
        .whereIdIn(this.sectionsIds)
        .get();
    },
    user() {
      return User.query().first();
    }
  },

  watch: {
    user: {
      immediate: true,
      handler(user) {
        if (user) {
          this.fetch(user);
        }
      }
    }
  },

  methods: {
    async fetch(user) {
      this.isFetching = true;

      let promise = await Section.api().fetchLiveSection(user.id);

      this.isFetching = false;

      if (promise?.response) {
        const { data = [] } = promise.response;

        this.sectionsIds = map(data, 'id');
      }
    }
  }
};
</script>
